// extracted by mini-css-extract-plugin
module.exports = {"customIconColor":"Static_customIconColor__FBOqD"};